const STORAGE_KEY = 'itg-collection-filters-collapsed';
const COLLAPSED_CLASS = 'itg-collection--filters-collapsed';
const FLIP_DURATION = 450;
const FLIP_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

function readCollapsed() {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    if (value === 'true') return true;
    if (value === 'false') return false;
    return null;
  } catch (error) {
    return null;
  }
}

function writeCollapsed(collapsed) {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(collapsed));
  } catch (error) {}
}

function syncToggle(collection) {
  const button = collection.querySelector('.itg-collection__filters-toggle');
  if (!button) return;
  button.setAttribute('aria-expanded', String(!collection.classList.contains(COLLAPSED_CLASS)));
}

function clearFlip(element) {
  if (element._itgFlipEnd) {
    element.removeEventListener('transitionend', element._itgFlipEnd);
    element._itgFlipEnd = null;
  }
  element.style.transition = '';
  element.style.transform = '';
  element.style.transformOrigin = '';
}

function flipProducts(items, first) {
  items.forEach((element, index) => {
    const start = first[index];
    const end = element.getBoundingClientRect();
    const dx = start.left - end.left;
    const dy = start.top - end.top;
    const sx = end.width ? start.width / end.width : 1;
    const sy = end.height ? start.height / end.height : 1;
    if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5 && Math.abs(sx - 1) < 0.01 && Math.abs(sy - 1) < 0.01) return;

    element.style.transition = 'none';
    element.style.transformOrigin = 'top left';
    element.style.transform = `translate(${dx}px, ${dy}px) scale(${sx}, ${sy})`;
    void element.offsetWidth;

    const onEnd = (event) => {
      if (event.target !== element || event.propertyName !== 'transform') return;
      clearFlip(element);
    };
    element._itgFlipEnd = onEnd;
    element.addEventListener('transitionend', onEnd);
    element.style.transition = `transform ${FLIP_DURATION}ms ${FLIP_EASING}`;
    element.style.transform = 'none';
  });
}

function applyCollapsed(collection, collapsed, animate) {
  const items = [...collection.querySelectorAll('.product-list > *')];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canAnimate = animate && !reduceMotion && window.matchMedia('(min-width: 1000px)').matches;
  const first = canAnimate ? items.map((element) => element.getBoundingClientRect()) : [];

  items.forEach(clearFlip);
  collection.classList.toggle(COLLAPSED_CLASS, collapsed);
  syncToggle(collection);
  writeCollapsed(collapsed);

  if (canAnimate) flipProducts(items, first);
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('.itg-collection__filters-toggle');
  if (!button) return;

  const collection = button.closest('.itg-collection');
  if (!collection) return;

  applyCollapsed(collection, !collection.classList.contains(COLLAPSED_CLASS), true);
});

function restoreCollapsed(collection) {
  const stored = readCollapsed();
  if (stored !== null) collection.classList.toggle(COLLAPSED_CLASS, stored);
  syncToggle(collection);
}

document.querySelectorAll('.itg-collection').forEach(restoreCollapsed);

document.querySelectorAll('.shopify-section--main-collection').forEach((section) => {
  new MutationObserver(() => {
    section.querySelectorAll('.itg-collection').forEach(restoreCollapsed);
  }).observe(section, { childList: true });
});
